import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

export const connectRaceInplayitem = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      betPlacing: state.betPlacing,
      exposure: state.eventPage.exposure,
      exposureRace: state.racePage.exposure,
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
